import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const fmsApi = createApi({
  reducerPath: 'fmss',
  tagTypes: ['Fms'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchFmss: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Fms', id: 'LIST' },
                ...result.map((r) => ({ type: 'Fms', id: r.id })),
              ]
            : [{ type: 'Fms', id: 'LIST' }],
        query: () => ({
          url: '?resource=fms&order=created_at.asc',
          method: 'GET',
        }),
      }),

      createFms: builder.mutation({
        invalidatesTags: [{ type: 'Fms', id: 'LIST' }],
        query: (data) => ({
          url: '?resource=fms',
          method: 'POST',
          body: data,
        }),
      }),

      updateFms: builder.mutation({
        invalidatesTags: (result, error, { id: fmsId }) => [
          { type: 'Fms', id: fmsId },
          { type: 'Fms', id: 'LIST' },
        ],
        query: ({ id: fmsId, submitData }) => ({
          url: `?resource=fms&id=eq.${fmsId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      fetchFms: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Fms', id: arg }],
        query: (fmsId) => ({
          url: `?resource=fms&id=eq.${fmsId}`,
          method: 'GET',
        }),
      }),

      fetchFmsByAthleteId: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Fms', id: 'LIST' },
                ...result.map((r) => ({ type: 'Fms', id: r.id })),
              ]
            : [{ type: 'Fms', id: 'LIST' }],
        query: (athleteId) => ({
          url: `?resource=fms&athlete=eq.${athleteId}&order=created_at.desc`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchFmssQuery,
  useCreateFmsMutation,
  useUpdateFmsMutation,
  useFetchFmsQuery,
  useFetchFmsByAthleteIdQuery,
} = fmsApi;

export { fmsApi };
